define(function(require) {
	// general
	const ViewManager = require('civicsUtils/view_manager');
	const MimeUtil = require('civicsUtils/mimetype_utilities');
	const Utils = require('civicsUtils/general_utilities');
	const AvailableFeatures = require('civicsUtils/available_features');
	// models
	const attachmentModel = require('civicsModels/attachment_model');
	// templates
	const tpl = require('civicsViews/attachments/templates/t_itv_add_attachment.hbs');
	const AttributesTable = require('./v_cpv_attributes');
	const constants = require('civicsUtils/constants');

	return Marionette.LayoutView.extend({
		initialize: function(options) {
			// if (__DEV__) console.log('itv_add_attachments -- initialize');
			this.config = $.extend({}, options.config);
			this.config.globalConfig = ViewManager.globalConfig();
			this.parentMoniker = options.parentMoniker;
			this.parentPrimaryKey = options.parentPrimaryKey;
			this.isAddProcess = options.isAddProcess;
			this.hasValidAttachment = true;
			this.documentTypes = options.documentTypeCollection;
			this.isCustomer = options.isCustomer;
			this.isProvider = options.isProvider;
			this.isEDMSupported = ViewManager.versionRange('8.8.0.0');
			this.validDocumentTypes = this.loadDocumentTypes();
			this.attachment_index = options.attachment_index;
			//filter only those that are add is turnoned

		},
		template: tpl,
		tagName: 'li',
		className: 'attachment-upload',
		modelEvents: {
			change: 'render',
		},
		events: {
			'click .delete-button': 'deleteAttachment',
			'droppyChange @ui.$documentType': 'onDocumentTypeChanged',
		},
		ui: {
			$deleteBtn: '.delete-button',
			$loadingIndicator: '.loading-indicator',
			$failed: '.rule-failed',
			$passed: '.rule-passed',
			comments: '.field-description .input-textarea',
			attachmentComments: '.description',
			$imagePreview: '.image-thumbnail',
			$nonImagePreview: '.non-image-thumbnail',
			$preview: '.preview',
			$documentType: '.document-type',
			$attributeTable: '.table-container',
		},
		regions: {
			attributeRegion: '@ui.$attributeTable'
		},
		templateHelpers: function() {
			var self = this;
			return {
				singleDocumentType: (typeof self.validDocumentTypes !== 'undefined' && self.validDocumentTypes.length == 1),
				documentTypes: _.sortBy(self.validDocumentTypes, function(o) {
					return o.portalDescription;
				}),
				isEDMSupported: self.isEDMSupported,
				fileType: self.model.get('fileName').substring(self.model.get('fileName').lastIndexOf('.')),
				deleteLabel: i18n.t('CIVICS.COMMON.DELETE_THIS', { type: i18n.t('CIVICS.ATTACHMENTS.ATTACHMENT'), id: self.model.get('fileName') }),
				attachment_index : this.attachment_index ? this.attachment_index : 0 //self.model.get('fileName').replace(/[^\w\s]/gi, '')
			};
		},
		onShow: function() {
			var self = this;
			this.ui.$attributeTable.hide();
			this.ui.$imagePreview.hide();
			this.ui.$nonImagePreview.hide();

			if (self.isEDMSupported) {
				if (self.model.get('File')) {

					var mimeType = self.model.get('File').type;

					if (typeof self.ui.$imagePreview === 'object' || typeof self.ui.$nonImagePreview === 'object') {
						if (mimeType != null && mimeType.split('/')[0] === 'image') {

							var attachmentReader = new FileReader();
							attachmentReader.onload = function(e) {
								if (typeof self.ui.$imagePreview === 'object') {
									self.ui.$imagePreview.attr('src', e.target.result);
									if(window.matchMedia("(max-width: 767px)").matches) {
										self.ui.$imagePreview.parent().css({'max-width':'150px', 'margin-bottom':'30px'});
									} else {
										self.ui.$imagePreview.parent().css('max-width', '200px');
									}
									self.ui.$imagePreview.parent().css('max-height', '200px');
									self.ui.$imagePreview.css('width', '100%');
									self.ui.$imagePreview.css('height', '100%');
								}

							}
							attachmentReader.readAsDataURL(self.model.get('File'));
							self.ui.$imagePreview.show();
						} else {
							self.ui.$nonImagePreview.show();
						}
					}


					if (self.validDocumentTypes.length == 1 || (typeof self.model.get('documentType') !== 'undefined' && typeof self.ui.$documentType === 'object')) {
						self.onDocumentTypeChanged();
					}
				}
			}
		},
		onRender: function() {
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInit();
			this.$el.find('textarea:not([aria-labelledby|="character-count-label"])').each(function(index, ta) {
				$(ta).maxlength();
			});
		},
		validateChildViewAttachment: function(view) {
			var self = this;
			self.clearErrorMessage();
			self.triggerMethod('attachment:before:save', view);
		},
		validateChildViewAttachment2: function(catalog) {
			var self = this;
			var data = Backbone.Syphon.serialize(self);
			self.hasValidAttachment = true;
			var validationError = {};
			var hasError = false;

			self.clearErrorMessage();

			//Get config values
			var maxSize = self.config.globalConfig.get("attachments").get("maxFileSize") * 1048576;
			var mimeTypes = self.config.globalConfig.get("attachments").get("mimeTypes");
			var allowedExts = self.config.globalConfig.get("attachments").get("allowedExtensions");
			if( allowedExts == undefined ) allowedExts = "";

			/*Validation for the file size*/
			var tempFile = self.model.get('file');
			if (tempFile.size > maxSize || tempFile.size > 252144000 ) {		//250MB max allowed regardless of config
				self.showError(i18n.t('CIVICS.ATTACHMENTS.UPLOAD_SIZE_ERROR'));
				self.hasValidAttachment = false;
			}

			/*Check for the mime type and/or extension type*/
			var mimeType = tempFile.type;
			var ext = tempFile.name.substring(tempFile.name.lastIndexOf('.'));
			if (tempFile.type.length == 0 && tempFile.name.length > 0 && tempFile.name.lastIndexOf('.') > 0) {
				mimeType = MimeUtil.getMimeType(ext);
			}
			if (typeof mimeType === 'undefined' || mimeType.length == 0 || mimeTypes.indexOf(mimeType) < 0) {
				//mime type is invalid.  Check the extension
				if( allowedExts.toLowerCase().indexOf(ext.toLowerCase()) < 0 ) {
					self.showError(i18n.t('CIVICS.ATTACHMENTS.UPLOAD_TYPE_ERROR'));
					self.hasValidAttachment = false;
				}
			}

			/*EDM Supported Validation*/
			if (self.isEDMSupported) {
				var error = {};
				if (typeof data.documentType === 'undefined' || data.documentType.length == 0) {
					//show error message that documenttype is required.
					error.validationError = {};
					error.validationError.documentType = i18n.t('CIVICS.ATTACHMENTS.DOCUMENT_TYPE_REQUIRED');
					hasError = true;
				} else {
					var attributes = [];

					if (typeof self.attributesTableView !== 'undefined' && self.attributesTableView.numDisplayedAttributes > 0) {
						var attributeData = ViewManager.fromWindow(self.ui.$attributeTable);
						var requiredAttributes = {};
						var requiredDocTypes = {};
						var numbers = ["integer", "short", "long", "float8", "currency", "decimal"];

						self.selectedDocumentType.get('attributes').each(function(a) {
							requiredAttributes[a.get('name')] = a.get('isRequired');
							requiredDocTypes[a.get('name')] = a.get('type');
						});

						for (attribute in attributeData) {
							if (requiredAttributes[attribute] == true && (_.isEmpty(attributeData[attribute]) || attributeData[attribute] == constants.DATE_TIME_MIN_VAL
								|| (numbers.indexOf(requiredDocTypes[attribute].toLowerCase()) != -1 && attributeData[attribute].toString() == '0' ))) {
								if (!this.isAddProcess) {
									hasError = true;
									validationError[attribute] = i18n.t('CIVICS.ATTACHMENTS.ATTRIBUTE_REQUIRED');
								}
							}
						}
					}
				}

				if (hasError && self.isEDMSupported) {
					self.hasValidAttachment = false;
					if (error)
						ViewManager.errorToWindow(error, this);

					if (!_.isEmpty(validationError) && !self.isAddProcess)
						this.displayAttributeErrors(validationError);
				}
			}
		},
		onUploadSave: function(catalog) {
			// if (__DEV__) console.log('itv_add_attachments -- onUploadSave');
			var def = new $.Deferred();
			var self = this;
			var data = Backbone.Syphon.serialize(self);
			ViewManager.resetErrorMessages(self);
			var tempFile = this.model.get('file');
			var mimeType = tempFile.type;

			var myModel = new attachmentModel();
			myModel.set('file', tempFile);
			myModel.set('description', data.description);
			myModel.set('fileName', this.model.get('fileName'));
			myModel.set('accountId', this.model.get('accountId'));

			//myModel.set('title', this.model.get('title'));

			//if this is 8.6+ we need the parent moniker and parent primary key
			if (ViewManager.versionRange('8.6.0.0')) {
				myModel.set('parentMoniker', self.parentMoniker);
				myModel.set('parentPrimaryKey', self.parentPrimaryKey);
			}

			var actualDocType = null;
			var missingRequirements = [];
			if (self.isEDMSupported) {
				var attributes = [];
				var documentType = {};
				myModel.set('title', data.title);
				myModel.set('provider', catalog);

				if (typeof self.attributesTableView !== 'undefined' && self.attributesTableView.numDisplayedAttributes > 0) {
					var attributeData = ViewManager.fromWindow(this.ui.$attributeTable);
					var requiredAttributes = {};

					self.selectedDocumentType.get('attributes').each(function(a) {
						requiredAttributes[a.get('name')] = a.get('isRequired');
					});

					for (attribute in attributeData) {
						if (self.isAddProcess) {
							if (requiredAttributes[attribute] == true && (_.isEmpty(attributeData[attribute]) || attributeData[attribute] == constants.DATE_TIME_MIN_VAL))
								missingRequirements.push(attribute);
						}

						if ((typeof attributeData[attribute] != 'undefined' && !_.isEmpty(attributeData[attribute])) || typeof attributeData[attribute] == 'boolean' ) {
							attributes.push({
								"name": attribute,
								"value": attributeData[attribute]
							});
						}

					}
				}

				actualDocType = self.documentTypes.find(function(doctype) {
					return doctype.get('name') == data.documentType;
				});

				if (self.validDocumentTypes.length == 1) {

					documentType = {
						"name": self.validDocumentTypes[0].name,
						"attributes": attributes
					};

				} else {


					documentType = {
						"name": data.documentType,
						"attributes": attributes
					};
				}


				myModel.set("documentType", documentType);

			} else {
				myModel.set('catalog', catalog);
				myModel.set('title', this.model.get('title'));
			}

			var shouldWeSave = !(ViewManager.versionRange('8.6.0.0') && this.isAddProcess);

			if (shouldWeSave) {
				myModel.isSave = true;
				myModel.save(null, {
					success: function() {
						self.ui.$deleteBtn.hide();
						self.ui.comments.attr('disabled', true);
						myModel.set('fileName', self.model.get('fileName'));
						myModel.set('id', myModel.attachmentId);

						if(actualDocType) {
							myModel.set('documentType',actualDocType);
						}

						self.triggerMethod('attachment:post:save', myModel);
						self.showSuccess(i18n.t('CIVICS.ATTACHMENTS.UPLOADED_AND_SAVED'));
						//window.location.reload(false);
						def.resolve(myModel);
					},
					error: function(model, response, options) {
						self.ui.$deleteBtn.show();
						self.showError(i18n.t('CIVICS.ATTACHMENTS.ERROR_UPLOADING_FILE'));
						def.reject();
					},
				});
			} else {
				self.ui.comments.attr('disabled', true);
				self.showSuccess(i18n.t('CIVICS.ATTACHMENTS.UPLOADED_AND_SAVED'));
				myModel.set('missingRequirements', missingRequirements);
				self.triggerMethod('attachment:post:save', myModel);
				def.resolve(myModel);
			}

			return def.promise();
		},
		onSaveDescription: function() {
			var self = this;
			var data = Backbone.Syphon.serialize(this);

			if (self.isEDMSupported) {
				var attributes = [];
				var documentType = {};
				var droppyValue = data.documentType;

				if (typeof droppyValue !== 'undefined' && droppyValue.length > 0) {

					if (typeof self.attributesTableView !== 'undefined' && self.attributesTableView.numDisplayedAttributes > 0) {
						var attributeData = ViewManager.fromWindow(self.ui.$attributeTable);
						for (attribute in attributeData) {
							attributes.push({
								"name": attribute,
								"value": attributeData[attribute]
							});
						}
					}

					documentType = {
						"name": data.documentType,
						"attributes": attributes
					};

					self.model.set("documentType", documentType);
					self.model.set('title', data.title);
				}
			}
			this.model.set('description', data.description);
		},
		deleteAttachment: function() {
			this.triggerMethod('attachment:remove');
		},
		clearErrorMessage: function() {
			this.ui.$failed.find('.error-message').remove();
			ViewManager.resetErrorMessages(this);
		},
		showError: function(message) {
			if (this.ui.$failed.text().indexOf(message) < 0) {
				var newError = $('<div class="error-message"></div>');
				newError.append(Utils.outputErrorMessage(message));
				this.ui.$failed.append(newError);
			}
			this.ui.$failed.show();
		},
		showSuccess: function(message) {
			this.ui.$passed.append(message);
			this.ui.$passed.show();
		},
		loadDocumentTypes: function() {
			var self = this;
			if (self.isEDMSupported) {
				var filteredDocumentTypeCollection = [];
				$.each(self.documentTypes.toJSON(), function(i, obj) {
					$.each(obj.portalConfigurations, function(idx, config) {
						if (self.isCustomer && !self.isProvider) {
							//Customer
							if (config.action == "Add" && config.customer === true) {
								var description = obj.description.length > 0 ? obj.description : obj.name;
								filteredDocumentTypeCollection.push({
									name: obj.name,
									portalDescription: obj.portalDescription.length > 0 ? obj.portalDescription : description,
								});
							}
						} else if (self.isProvider && !self.isCustomer) {
							//Service Provider
							if (config.action == "Add" && config.serviceProvider === true) {
								var description = obj.description.length > 0 ? obj.description : obj.name;
								filteredDocumentTypeCollection.push({
									name: obj.name,
									portalDescription: obj.portalDescription.length > 0 ? obj.portalDescription : description,
								});
							}
						} else {
							//for public.
							if (config.action == "Add" && config.public === true) {
								var description = obj.description.length > 0 ? obj.description : obj.name;
								filteredDocumentTypeCollection.push({
									name: obj.name,
									portalDescription: obj.portalDescription.length > 0 ? obj.portalDescription : description,
								});
							}
						}

					});
				});
				return filteredDocumentTypeCollection;
			}
		},
		onDocumentTypeChanged: function() {
			this.selectedDocumentType = null;
			var self = this;
			var droppyValue = Utils.civicsDropdownValue(this.ui.$documentType);

			if (self.validDocumentTypes.length == 1) {
				self.selectedDocumentType = this.documentTypes.find(function(doctype) {
					return doctype.get('name') == self.validDocumentTypes[0].name;
				});
			} else {
				self.selectedDocumentType = this.documentTypes.find(function(doctype) {
					return doctype.get('name') == droppyValue;
				});
			}

			if (droppyValue.length > 0 || self.validDocumentTypes.length == 1) {

				var attributesCollection = [];
				attributesCollection = self.selectedDocumentType.get('attributes');

				var modelsToRemove = [];

				attributesCollection.each(function(attr) {
					var remove = true;
					//remove those that are not showInPortal
					if (attr.get('showInPortal')) {
						remove = false;
					}

					if (remove) {
						modelsToRemove.push(attr);
					}

				});
				attributesCollection.remove(modelsToRemove);
				this.buildAttributeTable(attributesCollection);
			} else {
				self.ui.$attributeTable.hide();
			}

		},
		buildAttributeTable: function(attributesCollection) {
			var self = this;
			var today = new Date();

			var filteredAttributes = [];

			if (self.isCustomer || self.isProvider) {
				filteredAttributes = new Backbone.Collection(attributesCollection.filter(function(at) {
					if(AvailableFeatures.FilterOldAttachmentAttributes())
						return true;
					else
						return at.get('showInPortal') && (at.get('expire').includes(constants.DATE_TIME_MIN_VAL) || new Date(at.get('expire')) > today)
								&& (at.get('effective').includes(constants.DATE_TIME_MIN_VAL) || new Date(at.get('effective')) <= today);;
				}));
			} else {
				filteredAttributes = new Backbone.Collection(attributesCollection.filter(function(at) {
					if(AvailableFeatures.FilterOldAttachmentAttributes())
						return at.get('isPublic');
					else
						return at.get('showInPortal') && at.get('isPublic') && (at.get('expire').includes(constants.DATE_TIME_MIN_VAL)  || new Date(at.get('expire')) > today)
					 				&& (at.get('effective').includes(constants.DATE_TIME_MIN_VAL) || new Date(at.get('effective')) <= today);
				}));
			}

			if (filteredAttributes.length > 0) {

				filteredAttributes.comparator = function(model) {
					return model.get('displayOrder');
				};
				filteredAttributes.sort();

				if (typeof self.model.get('documentType') !== 'undefined') {
					var attributesFromModel = (typeof self.model.get('documentType').attributes !== 'undefined') ? self.model.get('documentType').attributes : "";

					if (attributesFromModel.length > 0) {
						filteredAttributes.each(function(item) {
							item.set('attributeValue', null);

							var attrib = attributesFromModel.find(function(attr) {
								return attr.name == item.get('name');
							});
							if (attrib != null) {
								item.set('attributeValue', attrib.value);
							}
						});
					}
				} else {
					//reset attributeValue.
					filteredAttributes.each(function(item) {
						item.set('attributeValue', null);
					});
				}

				this.attributesTableView = new AttributesTable({
					config: self.config,
					collection: filteredAttributes,
					numDisplayedAttributes: filteredAttributes.length,
					canUpdate: true,
					attachment_index:this.attachment_index
				});

				self.attributeRegion.show(this.attributesTableView);
				self.ui.$attributeTable.show();
			} else {
				self.ui.$attributeTable.hide();
			}
		},
		displayAttributeErrors: function(validationError) {
			// ViewManager.errorToWindow doesn't work here
			// because the fields are formatted differently
			for (error in validationError) {
				var selector = "[name='{0}']".format(error);
				var formElement = this.ui.$attributeTable.find(selector);

				var newError = $('<div class="helper-msg-container"><div class="error-message"></div></div>');
				newError.find(".error-message").append(Utils.outputErrorMessage(ViewManager.htmlSafeString(validationError[error])));

				formElement.closest('div.field').append(newError);
				formElement.parents('.field').addClass('error');
			}
			this.showError(i18n.t('CIVICS.ATTACHMENTS.MISSING_REQUIRED_INFO'));
		},
	});
});
